import React from "react"
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom"
import Header from "./components/Header"
import Footer from "./components/Footer"
import Home from "./pages/Home"
import Wallet from "./pages/Wallet"
import Aboutus from "./pages/AboutUs"
import CardDetails from "./pages/CardDetails"
import PointsSearch from "./pages/PointsSearch"

function App() {
  const location = useLocation()

  return (
    <>
      {location.pathname !== "/" && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/card/:id" element={<CardDetails />} />
        <Route path="/points-search" element={<PointsSearch />} />
      </Routes>
      <Footer />
    </>
  )
}

function AppWrapper() {
  return (
    <Router basename="/">
      <App />
    </Router>
  )
}

export default AppWrapper
